import { render, staticRenderFns } from "./ReportChannelFilter.vue?vue&type=template&id=32d7ae4a"
import script from "./ReportChannelFilter.vue?vue&type=script&lang=js"
export * from "./ReportChannelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports